export const mapBlockTemplate = {
    'CUSTOMER_NAME': {
        component: 'UpdateCustomerName'
    },
    'CUSTOMER_CORP_NAME': {
        component: 'UpdateCustomerName'
    },
    'CUSTOMER_PHONE': {
        component: 'UpdatePhone'
    },
    'CUSTOMER_MAIN_MAIL': {
        component: 'UpdateMail'
    },
    'CUSTOMER_SELF_ASSET': {
        component: 'UpdateSelfAsset'
    },
    'CUSTOMER_FX_INVEST': {
        component: 'UpdateFxInvestPurpose'
    },
    'CUSTOMER_PASSWORD': {
        component: 'UpdatePwd'
    },
    'SECOND_PASSWORD': {
        component: 'UpdateSecondPwd'
    },
    'CUSTOMER_CRYPT_INVEST': {
        component: 'UpdateCryptoInvestPurpose'
    },
    'MY_NUMBER_UPLOAD': {
        component: 'UpdateMyNumber'
    },
    'CUSTOMER_ADDRESS': {
        component: 'UpdateCustomerAddress'
    },
    'DOCUMENT_ID_UPLOAD': {
        component: 'UploadIdDocument'
    },
    'REGISTERED_PASSKEYS_BLOCK': {
        component: 'RegisteredPasskeys'
    },
}

export default {};
















